import ProductDescription from './ProductDescription'

const CannedBeansProduct = {
  ...ProductDescription,
  category: '06',
  subCategory: '003',
  IsBroadband: true,
  SaltContent: '',
  PBContainerSize: '',
}

export default CannedBeansProduct
